import { useApiGet } from '../../api/Api.hooks';
import { Screen, ScreenSection } from '../../models/Screen';

export function useGetScreen(idOrSection: number | ScreenSection) {
  const { data, isLoading, error, get } = useApiGet<Screen>(
    `screens/${idOrSection}`
  );
  return {
    screen: data,
    loadingScreen: isLoading,
    loadingScreenError: error,
    getScreen: get
  };
}
